;(function ($, window, document) {
  function onDOMContentLoaded() {
    var panels = $('.claims-collapse__header')

    // helper function to determine if current element (el) is in view
    function isInViewport(el) {
      if (!el) {
        return true
      }
      var elementTop = $(el).offset().top
      var elementBottom = elementTop + $(el).outerHeight()

      var viewportTop = $(window).scrollTop()
      var viewportBottom = viewportTop + $(window).height()

      return elementBottom > viewportTop && elementTop < viewportBottom
    }

    // loop all claims-collapse panels
    for (var i = 0; i < panels.length; i++) {
      // add click event listeners
      panels[i].addEventListener('click', function () {
        // in the case of click event ...
        // $(this) is the current collapse button being clicked

        var currentIsOpen = false
        // see if current panel is already open or not
        var attr = $(this).attr('aria-expanded')
        if (typeof attr !== 'undefined' && attr !== false && attr === 'true') {
          currentIsOpen = true
        }

        // loop through all panels
        // toggle button's and panel's classes and attributes
        for (var j = 0; j < panels.length; j++) {
          // open the current collapse if it WAS NOT open already otherwise close
          // this check is done to avoid unnecessary toggle of classes and attributes
          if (!currentIsOpen && $(this).attr('id') === $(panels[j]).attr('id')) {
            // open collapse
            $(this).attr({ 'aria-expanded': true })
            $(this).next('.collapse').addClass('in').attr({ hidden: false })
            $(this).find('.collapse-content__chevron').addClass('open')
          } else {
            // close collapse
            $(panels[j]).attr({ 'aria-expanded': false })
            $(panels[j]).next('.collapse').removeClass('in').attr({ hidden: true })
            $(panels[j]).find('.collapse-content__chevron').removeClass('open')
          }
        }

        if (!currentIsOpen) {
          // Scroll newly opened collapse into view if it is not visible on screen.
          //   If the currently open collapse is tall and its open button is scrolled out of view while
          //   its collapse's contents are still in view when new a collapse is opened,
          //   the newly opened collapse will open outside of view.
          if (!isInViewport(this)) {
            var ofs = 200 // offset number of pixels the screen goes "above" current target.
            var ani = 0 // speed of animation in milliseconds (0 = instant, higher ms = smoother scroll).
            $([document.documentElement, document.body]).animate({
              scrollTop: $(this).offset().top - ofs
            }, ani);
          }
        }
      })
    }
  }
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
})($, window, document)
